export enum Route {
  HOME = '/',
  OUR_STORY = '/our-story',
  OUR_BLOG = '/blogs',
  HOW_IT_WORKS = '/how-it-works',
  VISIONARIES = 'https://www.hiwaldo.com/pages/visionaries',
  CONTACT_US = '/help',
  MY_ACCOUNT = '/account',
  CHECKOUT = '/checkout',
  MEMBER_LOGIN = '/doctor/login',
  PATIENT_DOCTOR = '/doctor/patient/doctor',
  PATIENT_REGISTER = '/doctor/patient/register',
  PATIENT_PRESCRIPTION = '/doctor/patient/prescription',
  PATIENT_PLAN = '/doctor/patient/plan',
  PATIENT_SHIPPING = '/doctor/patient/shipping',
  PATIENT_ORDER_REVIEW = '/doctor/patient/order-review',
  PATIENT_PAYMENT_DETAILS = '/doctor/patient/payment-details',
  PATIENT_WELCOME_CONGRATS = '/doctor/patient/welcome/congrats',
  GET_STARTED = '/get-started',
  AMBASSADOR = '/ambassador',
  JOIN = '#contactUsForm',
  JOIN_BIO = '/ambassador/join/bio',
  JOIN_SOCIAL = '/ambassador/join/social',
  JOIN_COMPLETED = '/ambassador/join/completed',
  DOCTORS = '/',
  HELP = 'https://app.hiwaldo.com/help',
  BLOG = 'https://www.hiwaldo.com/blogs/posts',
  REVIEWS = 'https://www.hiwaldo.com/pages/reviews',
  ABOUTUS = 'https://www.hiwaldo.com/pages/our-story',
  PRIVACY_POLICY = 'https://www.hiwaldo.com/pages/privacy-policy',
  COOKIE_POLICY = 'https://www.hiwaldo.com/pages/cookies-policy',
  TERMS_SERVICE = 'https://www.hiwaldo.com/pages/terms-conditions',
  CHECKOUT_PAYPAL_RETURN_URL = '/doctor/patient/paypal/complete',
  CHECKOUT_PAYPAL_CANCEL_URL = '/doctor/patient/paypal/failure',
}
